"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Icons = require("../Icons");

var _reactI18next = require("react-i18next");

var MobileDownloadModal = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var isOpen = _ref.isOpen,
      toggle = _ref.toggle;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var downloadBackgroundUrl = t('mobile.popup.pic.url');
  var title = t('mobile.download.title');
  var body = t('mobile.download.body');
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: 'md',
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-60vh justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 flex-grow",
    style: {
      background: "url(".concat(downloadBackgroundUrl, ") center/cover no-repeat")
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-30vh flex flex-col justify-between px-8 pt-6 md:pt-8 pb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'text-dark text-2xl'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'text-light text-lg pt-4'
  }, body)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row items-center"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.AppleAppStoreIcon, {
    style: {
      height: '3rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-4"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.GooglePlayStoreIcon, {
    style: {
      height: '3rem'
    }
  }))))));
});

var _default = MobileDownloadModal;
exports["default"] = _default;
//# sourceMappingURL=index.js.map